import styled from 'styled-components';

export default styled.div`
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
    p {
      width: 100%;
      text-align: left;
      padding-top: 16px;
    }
  }

  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
`;
